module.exports = __webpack_public_path__ + "img/icon.7c134b08.png";